import { render, staticRenderFns } from "./OrderTypeOption.vue?vue&type=template&id=16dc4427&scoped=true&"
import script from "./OrderTypeOption.vue?vue&type=script&lang=js&"
export * from "./OrderTypeOption.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypeOption.vue?vue&type=style&index=0&id=16dc4427&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dc4427",
  null
  
)

export default component.exports